import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import {
  loadViolationsByIdFailed,
  loadViolationsByIdSuccessful,
} from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL_V2 } from '../../../configs';

export default function* loadViolationById(action) {
  try {
    const url = `${BACKEND_URL_V2}/dict/violations/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadViolationsByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadViolationsByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadViolationsByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
